import React from "react";

function Footer() {
    return (
        <footer><div>Copyright 2026</div><a className="cred" href="https://www.flaticon.com/free-icons/moon" title="moon icons">Moon icons created by Freepik - Flaticon</a>
        <div>zane.dance</div></footer>
    )
  }

  export default Footer;